import * as React from "react";
import styled from "styled-components";
import {
  ConstColor,
  ConstShadow,
} from "../../../../config/styles_const/styles_const";

const SlideNextArrow: React.FC<any> = (props) => {
  const { className } = props;
  const isDisabled = className.includes("disabled");

  return (
    <StyledArrow {...props} className={`prev ${isDisabled ? "disabled" : ""}`}>
      <Flex>
        <StyleI className="fas fa-angle-right" />
      </Flex>
    </StyledArrow>
  );
};

export default SlideNextArrow;

const StyledArrow = styled.div`
  position: absolute;
  right: -45px;
  top: 40%;
  height: 40px;
  width: 40px;

  background: ${ConstColor.White};

  box-shadow: ${ConstShadow.DropShadow};
  border-radius: 20px;
  cursor: pointer;

  &.disabled {
    cursor: default;
  }

  & i {
    color: ${ConstColor.Corporate};
  }
  &.disabled i {
    color: ${ConstColor.PlaceholderAndBorder};
  }
`;

const Flex = styled.div`
  display: flex;
  height: 100%;
  width: 100%;
  justify-content: center;
  align-items: center;
`;

const StyleI = styled.i``;



// WEBPACK FOOTER //
// ./src/presentation/common/atom/slider_arrow/slide_next_arrow.tsx